<template>

	<div id="App">

		<Header />

		<router-view />

		<Footer />

	</div>

</template>

<script>
	import Header from "./components/Header/Header";
	import Footer from "./components/Footer/Footer";
	
	
	
	export default {
		name: 'app',
		components: {
			Header,
			Footer
		},
		methods: {

		},
		created () {
			window.addEventListener('mousedown', () => {
				if (this.$root.timeout !== null) {
					clearTimeout(this.$root.timeout);
				}

				this.$root.timeout = setTimeout(() => {
					this.$router.push('/');
					this.$root.timeout = null;
				}, 120000);
			});
		}
	}
</script>